import { Theme } from '@mui/material';
import { WbText } from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import packageJson from '../../../package.json';

const useStyles = makeStyles()((theme: Theme) => ({
    textColor: {
        color: theme.palette.grey[400],
    },
    buildInfo: {
        marginLeft: 'auto',
        color: theme.palette.grey[400],
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            textAlign: 'center',
        },
    },
}));

function BuildInfo() {
    const { classes } = useStyles();

    const buildInfo = {
        version: packageJson.version,
    };

    return (
        <div className={classes.buildInfo}>
            <WbText size="m" className={classes.textColor}>
                Build: 2.{buildInfo.version}
            </WbText>
        </div>
    );
}

export default BuildInfo;
